import styles from './styles.module.scss';

import { Token, TokenItem } from '../Token';

type TokenizerProps = {
    id: string;
    tokens: TokenItem[];
    setTokens: React.Dispatch<React.SetStateAction<TokenItem[]>>;
    deletable?: boolean;
    wrapperText?: string;
    wrapperDescription?: string;
};

export const Tokenizer = ({
    id,
    tokens,
    setTokens,
    deletable = true,
    wrapperText,
    wrapperDescription
}: TokenizerProps) => {
    const onDeleteToken = (key: any) => {
        const currentTokens: TokenItem[] = [];

        tokens.forEach((token: TokenItem) => {
            if (token.key !== key) {
                currentTokens.push(token);
            }
        });

        setTokens(currentTokens);
    };

    const renderToken = (token: TokenItem) => {
        return (
            <Token
                key={`${id}-${token.key}`}
                wrapperText={wrapperText}
                wrapperDescription={wrapperDescription}
                text={token.text}
                description={token.description}
                title={token.title}
                deletable={deletable}
                onDelete={() => onDeleteToken(token.key)}
            />
        );
    };

    return <div className={styles.wrapper}>{tokens.map(renderToken)}</div>;
};
